import Jumbotron from "components/Jumbotron";
import React, { useEffect } from "react";
import styled from "styled-components/macro";
import StoreReview from "components/StoreReview";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStoreReviews,
  selectStoreReviews,
  selectStoreReviewsLoading,
} from "./storeReviewsSlice";
import Preloader from "components/Preloader/Preloader";

interface StoreReviewsProps {}

const StoreReviews: React.FC<StoreReviewsProps> = ({}) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectStoreReviewsLoading);
  const storeReviews = useSelector(selectStoreReviews);

  useEffect(() => {
    dispatch(fetchStoreReviews());
  }, []);

  return (
    <Jumbotron>
      <h2>Клиентите за нас</h2>
      <Reviews>
        {isLoading ? (
          <LoaderContainer>
            <Preloader />
          </LoaderContainer>
        ) : (
          <Swiper
            loop
            pagination
            breakpoints={{
              1: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {storeReviews.map((review) => {
              return (
                <SwiperSlide
                  key={review.reviewerName}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <StoreReview review={review} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </Reviews>
    </Jumbotron>
  );
};

const Reviews = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

const SectionTitleStyled = styled.p``;

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

export default StoreReviews;
